import { createSlice } from "@reduxjs/toolkit"

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        userId: "",
        products: [],
        discount: 0,
        totalQuantity: 0,
        amount: 0,
        deliveryAddress: {},
        invoiceAddress: {},
        sameAddress: true,
        paymentMethod: "",
        shippingMethod: "",
        shippingPrice: 0,
    },
    reducers: {
        updateCart: (state, action) => {
            state.userId = action.payload.userId
            state.discount = action.payload.discount
            state.deliveryAddress = action.payload.deliveryAddress
            state.invoiceAddress = action.payload.invoiceAddress
            state.sameAddress = action.payload.sameAddress
            state.paymentMethod = action.payload.paymentMethod
            state.shippingMethod = action.payload.shippingMethod
            state.shippingPrice = action.payload.shippingPrice
        },
        clearCart: (state) => {
            state.userId = ""
            state.products = []
            state.discount = 0
            state.totalQuantity = 0
            state.amount = 0
            state.deliveryAddress = {}
            state.invoiceAddress = {}
            state.sameAddress = true
            state.paymentMethod = ""
            state.shippingMethod = ""
            state.shippingPrice = 0
        },
        addProduct: (state, action) => {
            const prevProduct = state.products.find((item => item._id === action.payload._id))
            let prevQuantity

            if (prevProduct) {
                prevQuantity = prevProduct.quantity
            }

            if (prevQuantity) {
                state.products.find((item => item._id === action.payload._id))["quantity"] = prevQuantity + action.payload.quantity
            } else {
                state.products.push(action.payload)
            }

            state.totalQuantity += action.payload.quantity
            state.amount += action.payload.unitPrice * action.payload.quantity
            state.paymentMethod = ""
            state.sameAddress = true
        },
        updateProduct: (state, action) => {
            state.products = action.payload.products
            state.totalQuantity = action.payload.totalQuantity
            state.amount = action.payload.amount
            state.paymentMethod = ""
            state.sameAddress = true
        }
    }
})

export const { clearCart, updateCart, addProduct, updateProduct } = cartSlice.actions
export default cartSlice.reducer